import { humanize, initials } from "@/util/helpers";
import { IUser } from "@/interfaces";

export class User {
  private _data!: IUser;

  constructor(data: User | IUser) {
    if (data instanceof User) {
      return data;
    }
    this._data = { ...data };
  }

  get email() {
    return this._data?.email || "";
  }

  set groups(groups: string[]) {
    this._data.groups = groups;
  }

  get groups() {
    return this._data?.groups || [];
  }

  get group() {
    return this._data?.groups[0] || "";
  }

  get organisationName() {
    return this._data?.organisationName || "";
  }

  get coverHolder() {
    return this._data?.coverHolder || "";
  }

  get username() {
    return this._data?.username || "";
  }

  get status() {
    return this._data?.status || "";
  }

  get role() {
    return this._data?.role || "";
  }

  get verifiedEmail() {
    return this._data?.verifiedEmail || "";
  }

  get name() {
    return humanize(this.email);
  }

  get lastLogin() {
    return this._data?.lastLogin || "";
  }

  get initials() {
    return initials(this);
  }
}
